import { create } from 'zustand';

interface UiState {
  searchOpen: boolean;
  setSearchOpen: (open: boolean) => void;

  mobileMenuOpen: boolean;
  setMobileMenuOpen: (open: boolean) => void;

  bookPickerOpen: boolean;
  setBookPickerOpen: (open: boolean) => void;

  chapterPickerOpen: boolean;
  chapterPickerBook: string | null;
  openChapterPicker: (book: string) => void;
  closeChapterPicker: () => void;

  tagPickerOpen: boolean;
  setTagPickerOpen: (open: boolean) => void;

  noteDialogId: string | null;
  openNoteDialog: (id: string) => void;
  closeNoteDialog: () => void;

  toast: { id: number; text: string } | null;
  showToast: (text: string) => void;
}

let toastCounter = 0;

export const useUi = create<UiState>((set) => ({
  searchOpen: false,
  setSearchOpen: (open) => set({ searchOpen: open }),

  mobileMenuOpen: false,
  setMobileMenuOpen: (open) => set({ mobileMenuOpen: open }),

  bookPickerOpen: false,
  setBookPickerOpen: (open) => set({ bookPickerOpen: open }),

  chapterPickerOpen: false,
  chapterPickerBook: null,
  openChapterPicker: (book) => set({ chapterPickerOpen: true, chapterPickerBook: book }),
  closeChapterPicker: () => set({ chapterPickerOpen: false, chapterPickerBook: null }),

  tagPickerOpen: false,
  setTagPickerOpen: (open) => set({ tagPickerOpen: open }),

  noteDialogId: null,
  openNoteDialog: (id) => set({ noteDialogId: id }),
  closeNoteDialog: () => set({ noteDialogId: null }),

  toast: null,
  showToast: (text) => {
    const id = ++toastCounter;
    set({ toast: { id, text } });
    setTimeout(() => {
      set((s) => (s.toast?.id === id ? { toast: null } : s));
    }, 2400);
  },
}));
